import { useContext, useEffect, useState } from "react";
import {
  HiOutlineArrowSmLeft,
  HiOutlineArrowSmRight,
  HiOutlineUpload,
} from "react-icons/hi";

import { Button } from "../../../UI";
import { GeneralContext } from "../../../contexts/general.context";
import { TranscriptRequestContext } from "../../../contexts/transcriptRequest";
import classes from "./DestinationInfo.module.css";
import { toast } from "react-toastify";
import { ImSpinner3 } from "react-icons/im";

export const DocumentSelect = ({ setCurrentStep }) => {
  const [documentNames, setDocmentNames] = useState({});
  const [uploadingOfficailFile, setUploadingOfficailFile] = useState(false);
  const [uploadingAttachedFile, setUploadingAttachedFile] = useState(false);
  const { uploadFile, transcriptReceiptRequired } = useContext(GeneralContext);
  const { transcriptInfo, setTranscriptInfo, requestType } = useContext(
    TranscriptRequestContext
  );
  //initialize the document object in the transcript info object
  useEffect(() => {
    setTranscriptInfo((prev) => ({
      ...prev,
      document: {
        previousTranscriptRecieptsUrl: "",
        clearanceORpaymentRecieptsUrl: "",
        attachingDocumentUrls: [""],
      },
    }));
    //eslint-disable-next-line
  }, []);

  const handleNextBtn = (e) => {
    e.preventDefault();
    if (documentNames?.officialDoc) {
      transcriptInfo.document.documentType = 1;
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBackBtn = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const onFileChange = async (e) => {
    const { files, id, name } = e.target;

    if (id === "officialDoc") {
      setUploadingOfficailFile(true);
    }
    if (id === "attachingDoc") {
      setUploadingAttachedFile(true);
    }
    const { data: documentUrl } = await uploadFile(files[0]);
    if (documentUrl) {
      setUploadingAttachedFile(false);
      setUploadingOfficailFile(false);
    } else {
      toast.error("Please reupload files");
      setUploadingAttachedFile(false);
      setUploadingOfficailFile(false);
    }
    if (!documentUrl) return;

    if (id === "attachingDoc") {
      transcriptInfo.document[name] = [documentUrl];
      setDocmentNames((prev) => ({ ...prev, [id]: [files[0].name] }));
      return;
    }
    transcriptInfo.document[name] = documentUrl;
    setDocmentNames((prev) => ({ ...prev, [id]: files[0].name }));
  };

  return (
    <form className={classes.documentSelect} onSubmit={handleNextBtn}>
      <h1>Upload Documents</h1>
      <div className={classes.documentSelect__documentContainer}>
        <h4>
          Official Document<span>*</span>
        </h4>
        <div className={classes.documentSelect__inputContainer}>
          <div className={classes.documentSelect__input}>
            {/* <Select /> */}

            <p>
              Provide Statement of result/ Clearance form/ Payment receipts
              (provide all receipts in a single pdf):
            </p>
            <label htmlFor="officialDoc">
              {uploadingOfficailFile ? (
                <ImSpinner3 className="animate-spin" size={22} />
              ) : (
                <>
                  <HiOutlineUpload /> Upload file
                </>
              )}
            </label>
            <input
              type="file"
              id="officialDoc"
              onChange={onFileChange}
              name="clearanceORpaymentRecieptsUrl"
              required
            />
            <p>{documentNames?.officialDoc}</p>
          </div>

          {requestType === "Reprint" || transcriptReceiptRequired ? (
            <div className={classes.documentSelect__input}>
              <p>Provide receipt of your last transcript request:</p>
              <label htmlFor="paymentReceipt">
                <HiOutlineUpload /> Upload file
              </label>
              <input
                type="file"
                id="paymentReceipt"
                onChange={onFileChange}
                name="previousTranscriptRecieptsUrl"
                required
              />
              <p>{documentNames?.paymentReceipt}</p>
            </div>
          ) : null}
        </div>
      </div>
      <div className={classes.documentSelect__documentContainer}>
        <h4>Attaching Document</h4>
        <div className={classes.documentSelect__inputContainer}>
          <div className={classes.documentSelect__input}>
            <label htmlFor="attachingDoc">
              {uploadingAttachedFile ? (
                <ImSpinner3 className="animate-spin" size={22} />
              ) : (
                <>
                  <HiOutlineUpload /> Upload file(s)
                </>
              )}
            </label>
            <input
              type="file"
              id="attachingDoc"
              onChange={onFileChange}
              name="attachingDocumentUrls"
            />
            {documentNames?.attachingDoc?.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </div>
        </div>
      </div>
      <div className="flex gap-8 justify-center">
        <Button onClick={handleBackBtn} variant="invert" className="flex gap-2">
          <HiOutlineArrowSmLeft size={20} />
          Back
        </Button>
        <Button type="submit" className="flex gap-2">
          Next <HiOutlineArrowSmRight size={20} />
        </Button>
      </div>
    </form>
  );
};
